// src/Services/fetchComisiones.js
import { ApiRequestInterceptorQS } from "./apiRequestQS";
import { COMISIONES } from "../Constants/Endpoinst";

const ENDPOINT = COMISIONES.comisiones;

// wrapper genérico
const callComisionesApi = (method, qs) =>
  ApiRequestInterceptorQS(ENDPOINT, method, qs);

/**
 * GET vendedores para comisiones
 */
export const getVendedoresComisiones = async () => {
  // pasamos solicitud=vendedores por querystring y método GET
  const { code, data } = await callComisionesApi("GET", { solicitud: "vendedores" });
  return { code, data };
};

/**
 * POST cálculo de comisiones anual y trimestral
 */
export const postComisionesComercialAnualMensual = async ({
  comercial_id,
  anio,
  fechaInicio,
  fechaFin,
}) => {
  const { code, data } = await callComisionesApi("POST", {
    solicitud:   "handlePostComisionesComercialAnualMensual",
    comercial_id,
    anio,
    fechaInicio,
    fechaFin,
  });
  return { code, data };
};
